module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2022.0ce26ce4.jpg";